/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';

import { SmartAssistantSwitchComponent } from './smart-assistant-switch.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        FormsModule,
    ],
    declarations: [SmartAssistantSwitchComponent],
    exports: [SmartAssistantSwitchComponent],
})
export class SmartAssistantSwitchModule { }
